<template>
  <div>
    <PageTitle :title="$t('global.cloud-server-resize')" />
    <Card :disable-title="true">
      <LoadingState v-if="!status.isLoaded || !packageStatus.isLoaded" :size="50" />
      <ErrorState v-else-if="packageStatus.isErrored" />
      <CloudServerResizeForm v-else :packages="packages" :server="server" />
    </Card>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CloudServerResizeForm from "@/components/smart/forms/CloudServerResizeForm";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "CloudServerResizePage",
  components: {
    CloudServerResizeForm,
    LoadingState,
    PageTitle,
    ErrorState,
    Card,
  },
  props: {
    cloudServerId: [Number, String],
  },
  setup(props) {
    const server = computed(() => store.state.cloudServers.item);
    const status = computed(() => store.state.cloudServers.status);
    const packages = computed(() => store.state.cloudServerPackages.list);
    const packageStatus = computed(() => store.state.cloudServerPackages.status);

    onMounted(() => {
      store.dispatch("cloudServers/get", props.cloudServerId);
      store.dispatch("cloudServerPackages/getList");
    });

    return {
      packages,
      packageStatus,
      server,
      status,
    };
  },
};
</script>
